const english_translation = {
    book_now: 'book now',
    loading_location_component: 'load stations',
    no_access: 'no access',
    loading_location_component_error: 'There was a server side error during loading. Please try again later.',
    price_per: 'price per ',
    hour: 'hour',
    day: 'day',
    week: 'week',
    month: 'month',
    quarter: 'quarter',
    year: 'year',
    ten_years: '10 years',
    bikes: 'bikes',
    location: 'Site:',
    resource: 'box',
    duration: 'tenancy',
    booking_until: 'booking until',
    price: 'price',
    oclock: '',
    tos_prefix: 'I did read the',
    tos: 'terms and conditions',
    tos_postfix: 'and agree to them.',
    book: 'book',
    booking: 'booking',
    email_address: 'e-mail address',
    location_free_notify_help: 'Sadly, the site is booked out. You can add your e-mail to our waiting list, to get a notification as soon as a box is free again.',
    subscribe_to_notify_list: 'get on waiting list',
    invalid_email: 'Please provide a valid e-mail address!',
    subscribe_to_notify_list_success: 'E-mail successfully added to waiting list. You will get notified as soon as a box is free.',
    please_choose: 'please choose',
}

export default english_translation;
